import { useMutation, useQuery } from "@apollo/client";

import { CLAIM_DAILY_CLIP, GET_CLIP_REWARDS } from "MVVM/GraphQL/rewards";
import { TBoost } from "MVVM/Utilities/Rewards/boosts";

// TODO: move ClipLimitModal and /rewards onto this; they still run their own copies.
export const useClipRewards = ({ skip = false } = {}) => {
  const { data, error } = useQuery(GET_CLIP_REWARDS, {
    skip,
    fetchPolicy: "cache-and-network",
  });
  const [claimDailyClip, { loading: claiming }] = useMutation(
    CLAIM_DAILY_CLIP,
    { refetchQueries: ["GetClipRewards"] },
  );

  const quota = data?.me?.clipQuotaNew;
  const freeDaysLeft = (quota?.freeDayLimit ?? 0) - (quota?.freeDays ?? 0);
  // A finished boost is not a way to earn any more, so it drops off.
  const openBoosts: TBoost[] = (quota?.boosts ?? []).filter(
    (boost: TBoost) => !boost.completed,
  );

  return { quota, error, claimDailyClip, claiming, freeDaysLeft, openBoosts };
};
